"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _onLoad = require("./functions/onLoad");

var _onResize = require("./functions/onResize");

var _onScroll = _interopRequireDefault(require("./functions/onScroll"));

var _getAll = _interopRequireDefault(require("./functions/getAll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WDHComponent =
/*#__PURE__*/
function () {
  /**
     * @param {string} selectorOrClassname - Either the css classname or a full css selector that identifies instances of this component
     * @example
     * import { WDHComponent } from '@demant/wdh';
     *
     *
     * // Using classname to identify
     * const myComponent = new WDHComponent('my-component');
     *
     * or
     *
     * // Using css selector to identify
     * const myComponent = new WDHComponent('.some-div > .my-component');
     */
  function WDHComponent(selectorOrClassname) {
    _classCallCheck(this, WDHComponent);

    selectorOrClassname = selectorOrClassname || '';
    /**
     * @private
     * @type {string}
     */

    this.componentSelector = this.isComplexSelector(selectorOrClassname) ? selectorOrClassname : ".".concat(selectorOrClassname);
    /**
     * @private
     * @type {Node[]}
     */

    this.components = [];
    /**
     * @private
     * @type {WDHVariation[]}
     */

    this.variations = [];
  }
  /**
     * Executes the class behavior and the support methods
     */


  _createClass(WDHComponent, [{
    key: "run",
    value: function run() {
      var _this = this;

      (0, _onLoad.onLoad)(function () {
        _this.components = (0, _getAll["default"])(_this.componentSelector);

        _this.components.forEach(function (component) {
          // Execute the javascript logic for the component
          try {
            _this.init(component);
          } catch (error) {
            console.log('Component init failed', _this.getComponentSelector(), error);
          } // Loop through registered style variations and execute their init method


          _this.variations.forEach(function (variation) {
            var className = variation.className;

            if (component.classList.contains(className)) {
              try {
                variation.init(component);
              } catch (error) {
                console.log('Variation init failed', className, error);
              }
            }
          });
        });

        (0, _onResize.onResize)(function () {
          _this.components.forEach(function (component) {
            // Execute the javascript logic for the component
            try {
              _this.resize(component);
            } catch (error) {
              console.log('Component resize failed', _this.getComponentSelector(), error);
            }

            _this.variations.forEach(function (variation) {
              var className = variation.className;

              if (component.classList.contains(className)) {
                try {
                  variation.resize(component);
                } catch (error) {
                  console.log('Variation resize failed', className, error);
                }
              }
            });
          });
        });
        (0, _onScroll["default"])(function (scrollTop) {
          _this.components.forEach(function (component) {
            // Execute the javascript logic for the component
            try {
              _this.scroll(component, scrollTop);
            } catch (error) {
              console.log('Component scroll failed', _this.getComponentSelector(), error);
            }

            _this.variations.forEach(function (variation) {
              var className = variation.className;

              if (component.classList.contains(className)) {
                try {
                  variation.scroll(component, scrollTop);
                } catch (error) {
                  console.log('Variation scroll failed', className, error);
                }
              }
            });
          });
        });
      });
    }
    /**
     * Executes the behavior/logic of the component on load. Override in subclass.
     *
     * @param {HTMLElement} component
     */

  }, {
    key: "init",
    value: function init(component) {}
    /* eslint-disable-line */
    // Only implement if the component has some logic.

    /**
     * Executes the behavior/logic of the component every time the page is resized. Override in subclass. Runs once on load.
     *
     * @param {HTMLElement} component
     */

  }, {
    key: "resize",
    value: function resize(component) {}
    /* eslint-disable-line */

    /**
     * Executes the behavior/logic of the component every time the page is scrolled. Override in subclass. Runs once on load.
     *
     * @param {HTMLElement} component
     * @param {number} scrollTop
     */

  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {}
    /* eslint-disable-line */

    /**
     * Returns the components unique css selector
     * @returns {string}
     */

  }, {
    key: "getComponentSelector",
    value: function getComponentSelector() {
      return this.componentSelector;
    }
    /**
     * Returns the set of html components on page matching the components unique css class name
     * @returns {HTMLElement[]}
     */

  }, {
    key: "getComponents",
    value: function getComponents() {
      return this.components;
    }
    /**
     *
     * @param {string} selector
     * @returns {boolean}
     * @private
     */

  }, {
    key: "isComplexSelector",
    value: function isComplexSelector(selector) {
      return selector.startsWith('#') || selector.startsWith('.') || selector.indexOf(',') > -1 || selector.indexOf(' ') > -1;
    }
    /**
      * Registers a variation of the component to be executed
      *
      * @param {WDHVariation} variation - Component variation to be registered
      */

  }, {
    key: "registerVariation",
    value: function registerVariation(variation) {
      this.variations.push(variation);
    }
  }]);

  return WDHComponent;
}();

var _default = WDHComponent;
exports["default"] = _default;